<div class="relative isolate w-max">
  <rid-audio-bubble class="absolute" #audioBubble />

  <button
    class="relative inline-block cursor-pointer border-2 border-transparent bg-emerald-500 shadow-emerald-600 transition-colors outline-none select-none hover:bg-emerald-600 hover:shadow-emerald-700 focus:bg-emerald-600 focus:shadow-emerald-700 active:shadow-[0_0_0]"
    [class]="
      size() === 'LARGE'
        ? 'rounded-xl p-8 shadow-[0_0.25em_0] active:translate-y-[0.25em]'
        : 'rounded-md p-4 shadow-[0_0.125em_0] active:translate-y-[0.125em]'
    "
    (click)="play()"
  >
    <i-speaker class="text-white" [class]="size() === 'LARGE' ? 'size-32' : 'size-16'" />
  </button>
</div>
